import {createRouter, createWebHistory} from 'vue-router'
import IndexView from '../views/IndexView.vue'
import CityView from '../views/CityView.vue'
import ServiceView from "@/views/ServiceView.vue";
import CustomerServiceView from "@/views/CustomerServiceView.vue";
import RepairView from "@/views/RepairView.vue";
import KnowledgeView from "@/views/KnowledgeView.vue";
import TechnologyView from "@/views/TechnologyView.vue";
import CasesView from "@/views/CasesView.vue";
import AboutView from "@/views/AboutView.vue";
import LoginView from "@/views/LoginView.vue";
import RegisterView from "@/views/RegisterView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import NewUserView from "@/views/NewUserView.vue";
import ProfileView from "@/views/ProfileView.vue";
import WorkOrderView from "@/views/WorkOrderView.vue";
import AddressView from "@/views/AddressView.vue";
import NewsView from "@/views/NewsView.vue";
import VideoView from "@/views/VideoView.vue";
import TestView from "@/views/TestView.vue";
import { updateSEO, updateCanonical } from '@/utils/seo'
import LeaseView from "@/views/LeaseView.vue";
import MemberView from "@/views/MemberView.vue";
import MemberBenefitsView from "@/views/MemberBenefitsView.vue";
import DownloadView from "@/views/DownloadView.vue";
import LeaseCenterView from "@/views/LeaseCenterView.vue";

// 检查是否登录
function requireAuth(to, from, next) {
    const token = localStorage.getItem('access_token')
    if (token) {
        next()
    } else {
        // 记录当前要访问的 URL（包括查询参数），登录成功后跳转回来
        const redirectUrl = to.fullPath || to.path
        next({
            path: '/login',
            query: {redirect: redirectUrl}
        })
    }
}

const routes = [
    {
        path: '/',
        name: 'index',
        component: IndexView,
        meta: {
            title: '智维驿 - 智能设备后市场服务数智化云平台',
            description: '智维驿是专业的智能设备后市场服务数智化云平台，提供制卡设备、智能设备、机器人、无人机、新能源设备、智能家电等各类设备的维修、保养、管理、租赁等服务。7×24小时全国服务热线：4008768770',
            keywords: '智维驿,智能设备维修,制卡设备维修,设备维修服务,机器人维修,无人机维修,新能源设备维修,智能家电维修,设备保养,设备管理,设备租赁'
        }
    },
    {
        path: '/city',
        name: 'city',
        component: CityView,
        meta: {
            title: '选择服务城市 - 智维驿',
            description: '选择您所在的城市，智维驿将为您提供本地化的智能设备维修服务。覆盖全国主要城市，7×24小时服务。',
            keywords: '智维驿,服务城市,本地化服务,设备维修,城市选择'
        }
    },
    {
        path: '/service',
        name: 'service',
        component: ServiceView,
        meta: {
            title: '全部服务 - 智维驿',
            description: '智维驿提供全面的智能设备维修服务，包括制卡设备、智能设备、机器人、无人机、新能源设备、智能家电等各类设备的维修、保养、管理、租赁服务。',
            keywords: '设备维修服务,制卡设备维修,智能设备维修,机器人维修,无人机维修,新能源设备维修,智能家电维修'
        }
    },
    {
        path: '/repair',
        name: 'repair',
        component: RepairView,
        beforeEnter: requireAuth,
        meta: {
            title: '一键报修 - 智维驿',
            description: '快速报修，享受专业的智能设备维修服务。智维驿提供便捷的在线报修服务，快速响应您的维修需求。',
            keywords: '设备维修下单,在线报修,维修服务,快速下单'
        }
    },
    {
        path: '/lease',
        name: 'lease',
        component: LeaseView,
        beforeEnter: requireAuth,
        meta: {
            title: '一键租赁 - 智维驿',
            description: '快速租赁，享受专业的智能设备维修服务。智维驿提供便捷的在线下单服务，快速响应您的维修需求。',
            keywords: '设备租赁下单,在线下单,租赁服务,快速下单'
        }
    },
    {
        path: '/customerServiceView',
        name: 'customerServiceView',
        component: CustomerServiceView,
        meta: {
            title: '免费咨询 - 智维驿',
            description: '智维驿提供免费的设备维修咨询服务，专业工程师在线解答您的设备问题，为您提供专业的维修建议和解决方案。',
            keywords: '设备维修咨询,免费咨询,在线咨询,维修建议,设备问题解答'
        }
    },
    {
        path: '/knowledge',
        name: 'knowledge',
        component: KnowledgeView,
        meta: {
            title: '维修知识 - 智维驿',
            description: '智维驿维修知识库，提供各类智能设备的维修知识、保养技巧、故障排除方法等专业内容，帮助您更好地维护设备。',
            keywords: '维修知识,设备保养,故障排除,维修技巧,设备维护'
        }
    },
    {
        path: '/technology',
        name: 'technology',
        component: TechnologyView,
        meta: {
            title: '前沿技术 - 智维驿',
            description: '了解智能设备维修领域的前沿技术和最新动态，智维驿为您带来行业最新的技术资讯和创新解决方案。',
            keywords: '前沿技术,维修技术,技术创新,技术资讯,智能设备技术'
        }
    },
    {
        path: '/cases',
        name: 'cases',
        component: CasesView,
        meta: {
            title: '客户案例 - 智维驿',
            description: '查看智维驿的成功维修案例，了解我们如何为客户解决各类智能设备维修问题，提供专业的维修服务。',
            keywords: '维修案例,成功案例,客户案例,设备维修案例'
        }
    },
    {
        path: '/about',
        name: 'about',
        component: AboutView,
        meta: {
            title: '关于我们 - 智维驿',
            description: '了解智维驿，专业的智能设备后市场服务数智化云平台。我们致力于为各类智能设备提供优质的维修、保养、管理、租赁服务。',
            keywords: '关于智维驿,公司介绍,企业简介,智维驿介绍'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: {
            title: '登录 - 智维驿',
            description: '登录智维驿账号，享受更多专业服务。',
            keywords: '登录,用户登录,账号登录'
        }
    },
    {
        path: '/register',
        name: 'register',
        component: RegisterView,
        meta: {
            title: '注册 - 智维驿',
            description: '注册智维驿账号，开启智能设备维修服务之旅。',
            keywords: '注册,用户注册,账号注册'
        }
    },
    {
        path: '/forgotPassword',
        name: 'forgotPassword',
        component: ForgotPasswordView,
        meta: {
            title: '忘记密码 - 智维驿',
            description: '找回您的智维驿账号密码。',
            keywords: '忘记密码,密码找回'
        }
    },
    {
        path: '/newUser',
        name: 'newUser',
        component: NewUserView,
        meta: {
            title: '新用户 - 智维驿',
            description: '新用户指南，帮助您快速了解智维驿的服务。',
            keywords: '新用户,用户指南'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: ProfileView,
        beforeEnter: requireAuth,
        meta: {
            title: '个人信息 - 智维驿',
            description: '管理您的个人信息和账户设置。',
            keywords: '个人信息,账户设置'
        }
    },
    {
        path: '/workOrder',
        name: 'workOrder',
        component: WorkOrderView,
        beforeEnter: requireAuth,
        meta: {
            title: '工单管理 - 智维驿',
            description: '查看和管理您的维修工单，跟踪维修进度。',
            keywords: '工单管理,维修工单,工单查询'
        }
    },
    {
        path: '/address',
        name: 'address',
        component: AddressView,
        beforeEnter: requireAuth,
        meta: {
            title: '地址管理 - 智维驿',
            description: '管理您的收货地址和服务地址。',
            keywords: '地址管理,收货地址'
        }
    },
    {
        path: '/news',
        name: 'news',
        component: NewsView,
        meta: {
            title: '新闻资讯 - 智维驿',
            description: '智维驿最新新闻和行业资讯，了解智能设备维修行业的最新动态。',
            keywords: '新闻资讯,行业资讯,最新动态'
        }
    },
    {
        path: '/video',
        name: 'video',
        component: VideoView,
        meta: {
            title: '维修视频 - 智维驿',
            description: '免费提供制卡设备维修视频，覆盖智能设备、机器人、无人机、新能源设备、智能家电等各类智能设备的维修服务。',
            keywords: '维修视频,设备维修视频,制卡设备维修,维修教程'
        }
    },
    {
        path: '/test',
        name: 'test',
        component: TestView,
        meta: {
            title: '维修视频 - 智维驿',
            description: '免费提供制卡设备维修视频，覆盖智能设备、机器人、无人机、新能源设备、智能家电等各类智能设备的维修服务。',
            keywords: '维修视频,设备维修视频,制卡设备维修,维修教程'
        }
    },
    {
        path: '/member',
        name: 'member',
        component: MemberView,
        beforeEnter: requireAuth,
        meta: {
            title: '会员中心 - 智维驿',
            description: '选择最适合您的会员套餐，解锁更多权益。智维驿提供月度会员和终身会员两种套餐选择。',
            keywords: '会员中心,会员套餐,月度会员,终身会员,会员权益'
        }
    },
    {
        path: '/memberBenefits',
        name: 'memberBenefits',
        component: MemberBenefitsView,
        beforeEnter: requireAuth,
        meta: {
            title: '我的会员权益 - 智维驿',
            description: '查看您当前享有的所有会员特权，包括视频生成次数、权益列表和使用统计。',
            keywords: '会员权益,会员特权,会员状态,视频生成次数'
        }
    },
    {
        path: '/download',
        name: 'download',
        component: DownloadView,
        meta: {
            title: '下载中心 - 智维驿',
            description: '智维驿下载中心，提供各类软件、文档、资料等文件下载服务，包括客户端安装包、使用手册、API文档等。',
            keywords: '下载中心,文件下载,软件下载,文档下载,客户端下载,安装包下载'
        }
    },
    {
        path: '/leaseCenter',
        name: 'leaseCenter',
        component: LeaseCenterView,
        beforeEnter: requireAuth,
        meta: {
            title: '租赁中心',
            description: '查看您的所有租赁记录，包括订单状态、支付信息等。',
            keywords: '租赁设备查询,订单列表,支付订单,订单管理'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// SEO路由守卫
router.beforeEach((to, from, next) => {
    // 应用SEO meta信息
    if (to.meta) {
        const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin
        const fullUrl = `${baseUrl}${to.fullPath}`
        
        updateSEO({
            title: to.meta.title,
            description: to.meta.description,
            keywords: to.meta.keywords
        })
        updateCanonical(fullUrl)
    }
    next()
})

export default router
